import { Injectable } from '@angular/core';
import { first } from "rxjs";
import { HTTP_ENDPOINTS } from "../external/http";
import { environment } from "../../environments/environment";
import { ActionDto, MachineId, TenantId } from "@allbesmart/web-app-common";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ActionsService {

  constructor(private http: HttpClient) {
  }

  public publishAction(tenantId: TenantId, machineId: MachineId, actionDto: ActionDto): void {
    // This subscription should not be handled because we don't want to cancel old actions from being sent
    this.http.post(`${environment.apiBasePath}/${HTTP_ENDPOINTS.MACHINES_PATH}/${tenantId}/${machineId}/${HTTP_ENDPOINTS.ACTIONS_PATH}`, actionDto)
      .pipe(first()).subscribe();
  }

}
